import { api } from "~/data/core/api";

import type { ExamDto, SaveExamDto } from "./exam.dto";
import type { SaveQuestionDto, QuestionDto } from "./question.dto";
import type {
  ChecklistDto,
  ChecklistsResponse,
  SaveChecklistDto,
} from "./checklist.dto";

export const getChecklists = async (params?: {
  page?: number;
  query?: string;
}) => {
  const entries =
    params &&
    Object.entries(params)
      .filter((it) => !!it[1])
      .map((it) => [it[0], String(it[1])]);
  const search = new URLSearchParams(entries);
  const { data } = await api.get<ChecklistsResponse>(
    "/api/v1/admin/checklists?" + search
  );
  return data;
};

export const createChecklist = async (
  checklist?: SaveChecklistDto
): Promise<ChecklistDto> => {
  const { data } = await api.post("/api/v1/admin/checklists", checklist);
  return data.data;
};

export const getChecklist = async (id: string): Promise<ChecklistDto> => {
  const { data } = await api.get(`/api/v1/admin/checklists/${id}`);
  return data.data;
};

export const updateChecklist = async (
  id: string,
  dto: SaveChecklistDto
): Promise<ChecklistDto> => {
  const { data } = await api.put(`/api/v1/admin/checklists/${id}`, dto);
  return data.data;
};

export const deleteChecklist = async (id: string): Promise<ChecklistDto> => {
  const { data } = await api.delete(`/api/v1/admin/checklists/${id}`);
  return data.data;
};

// Questions

export const getChecklistQuestions = async (checklistId: string) => {
  const { data } = await api.get<ChecklistQuestionsResponse>(
    `/api/v1/admin/checklists/${checklistId}/test_questions`
  );
  return { questions: data.data, categories: data.question_categories };

  interface ChecklistQuestionsResponse {
    data: QuestionDto[];
    question_categories: { id: string; name: string }[];
  }
};

export const createChecklistQuestion = async (
  checklistId: string,
  dto: SaveQuestionDto
): Promise<QuestionDto> => {
  const { data } = await api.post(
    `/api/v1/admin/checklists/${checklistId}/test_questions`,
    { test_question: dto }
  );
  return data.data;
};

export const updateChecklistQuestion = async (
  id: string,
  dto: SaveQuestionDto
): Promise<QuestionDto> => {
  const { data } = await api.put(`/api/v1/admin/test_questions/${id}`, {
    test_question: dto,
  });
  return data.data;
};

export const deleteChecklistQuestion = async (id: string) => {
  await api.delete(`/api/v1/admin/test_questions/${id}`);
};

// Exams

export const getChecklistExams = async (
  checklistId: string
): Promise<ExamDto[]> => {
  const { data } = await api.get(
    `/api/v1/admin/checklists/${checklistId}/test_exams`
  );
  return data.data;
};

export const createChecklistExam = async (
  checklistId: string,
  dto: SaveExamDto
): Promise<ExamDto> => {
  console.log("dto", dto);
  const { data } = await api.postForm(
    `/api/v1/admin/checklists/${checklistId}/test_exams`,
    { test_exam: dto }
  );
  return data.data;
};

export const updateChecklistExam = async (
  id: string,
  dto: SaveExamDto
): Promise<ExamDto> => {
  const { data } = await api.putForm(`/api/v1/admin/test_exams/${id}`, {
    test_exam: dto,
  });
  return data.data;
};

export const deleteChecklistExam = async (id: string): Promise<void> => {
  await api.delete(`/api/v1/admin/test_exams/${id}`);
};
